import { generateQueryString } from '../../../common/base/report/report-util';

export const queryStringCalc = ({
  reportConfig,
  criteria,
  token,
  devSetting,
  criteriaStats,
}) => {
  const params = [];
  const filters = {};

  if (reportConfig.filters.showBank) {
    filters.allBanks = criteriaStats.allBanks;
    if (!criteriaStats.allBanks && criteria.banks.length > 0) {
      filters.bankIds = criteria.banks;
    }
  }
  if (reportConfig.filters.showFromToDates && criteria.fromDate) {
    filters.fromDate = criteria.fromDate;
  }
  if (reportConfig.filters.showFromToDates && criteria.toDate) {
    filters.toDate = criteria.toDate;
  }
  if (reportConfig.filters.showOutstandingOnly) {
    filters.outstandingOnly = criteria.outstandingOnly;
  }
  if (Object.keys(filters).length > 0) {
    params.push(`filters=${encodeURIComponent(JSON.stringify(filters))}`);
  }

  if (token) {
    params.push(`token=${token}`);
  }

  /* For testcafe */
  if (devSetting && devSetting.isTestEnvironment) {
    params.push('isTestCafe=1');
  }

  return generateQueryString(params);
};

export const reportList = () => {
  const list = [
    {
      description: 'Treasurers Checks Report',
      config: {
        route: 'gl/treasurer-checks-report',
        filters: {
          showBank: true,
          showFromToDates: true,
          showOutstandingOnly: true,
        },
      },
    },
  ];
  return list;
};

export default {
  reportList,
  queryStringCalc,
};
